"use client";
import { useEffect, useState } from "react";
import SignupSlider from "../../Components/Signupslider/index";
import { useLocation, useNavigate } from "react-router-dom";
const AddBankDetails = () => {
  const Navigation = useNavigate();
  const location = useLocation();
  const initialData = location.state || {};
  const [errors, setErrors] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [isOpens, setIsOpens] = useState(false);
  const [form, setForm] = useState({
    name: location?.state?.name ? location?.state?.name : "",
    accountNumber: location?.state?.accountNumber
      ? location?.state?.accountNumber
      : "",
    reaccountNumber: location?.state?.reaccountNumber
      ? location?.state?.reaccountNumber
      : "",
    IFSCcode: location?.state?.IFSCcode ? location?.state?.IFSCcode : "",
  });
  const [selectedOptions, setSelectedOptions] = useState(
    location?.state?.selectedOptions?.[0] ||
      location?.state?.selectedOptions ||
      ""
  );
  const [selectedOptions2, setSelectedOptions2] = useState(
    location?.state?.selectedOptions2?.[0] ||
      location?.state?.selectedOptions2 ||
      ""
  );
  const options = [
    "HDFC BANK",
    "AXIS BANK",
    "YES BANK",
    "SBI BANK",
    "ICICI BANK",
  ];
  const optionstwo = ["Saving", "Current", "Deposite"];

  const toggleDropdown = () => setIsOpen((o) => !o);
  const toggleDropdowntwo = () => setIsOpens((o) => !o);

  const validateForm = () => {
    let valid = true;
    let newErrors = { ...(errors || {}) };

    if (!selectedOptions) {
      newErrors.bank = "Please select your bank";
      valid = false;
    } else {
      newErrors.bank = "";
    }

    if (!selectedOptions2) {
      newErrors.accountType = "Please select bank account type";
      valid = false;
    } else {
      newErrors.accountType = "";
    }

    // Validate Name (it shouldn't be empty and should contain only letters)
    if (!form.name) {
      newErrors.name = "Beneficiary name is required";
      valid = false;
    } else if (!/^[a-zA-Z\s]+$/.test(form.name.trim())) {
      newErrors.name = "Beneficiary name should contain only letters";
      valid = false;
    } else {
      newErrors.name = "";
    }

    // Validate Account Number (must be numeric and at least 10 digits)
    if (!form.accountNumber || !/^\d{10,}$/.test(form.accountNumber)) {
      newErrors.accountNumber =
        "Bank account number should be at least 10 digits long and numeric";
      valid = false;
    } else {
      newErrors.accountNumber = "";
    }

    // Validate Re-enter Account Number (must match original account number)
    if (form.reaccountNumber !== form.accountNumber) {
      newErrors.reaccountNumber = "Account numbers must match";
      valid = false;
    } else {
      newErrors.reaccountNumber = "";
    }

    // Validate IFSC Code (should be alphanumeric, typically 11 characters long)
    if (!form.IFSCcode || !/^[A-Za-z]{4}\d{7}$/.test(form.IFSCcode)) {
      newErrors.IFSCcode = "Invalid IFSC code";
      valid = false;
    } else {
      newErrors.IFSCcode = "";
    }

    setErrors(newErrors);
    return valid;
  };
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent the default form submission

    if (validateForm()) {
      // Navigate to the next page with the form data
      Navigation("/sign-up-vendor", {
        state: {
          ...initialData,
          ...form,
          selectedOptions: selectedOptions ? [selectedOptions] : [],
          selectedOptions2: selectedOptions2 ? [selectedOptions2] : [],
        },
      });
    } else {
      // Optionally, show an error or feedback to the user if validation fails
      console.log("Form is not valid.");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (location?.state?.accountNumber) {
      const data = {
        name: location.state.name,
        accountNumber: location.state.accountNumber,
        reaccountNumber: location.state.reaccountNumber,
        IFSCcode: location.state.IFSCcode,
      };
      setForm({ ...data });
      const bankOption = Array.isArray(location.state.selectedOptions)
        ? location.state.selectedOptions[0] || ""
        : location.state.selectedOptions || "";
      setSelectedOptions(bankOption);
      const accountTypeOption = Array.isArray(location.state.selectedOptions2)
        ? location.state.selectedOptions2[0] || ""
        : location.state.selectedOptions2 || "";
      setSelectedOptions2(accountTypeOption);
    }
  }, [location?.state]); // Ensure the effect runs when location.state changes

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isOpen && !e.target.closest(".add-bank-dropdown-bank")) {
        setIsOpen(false);
      }
      if (isOpens && !e.target.closest(".add-bank-dropdown-type")) {
        setIsOpens(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, isOpens]);

  return (
    <>
      <div className="w-full md:flex block">
        <div className="md:w-6/12 w-full">
          <div className="flex items-center justify-center h-screen">
            <div className="block md:w-80 w-10/12">
              <img src="images/black-logo.svg" alt="" className="mx-auto" />

              <h1 className="text-[27px] leading-[32px] text-black text-center py-4 font-BonaNovaRegular font-normal">
                Add Bank Details
              </h1>
              <form
                action="#"
                method="POST"
                className="space-y-3"
                onSubmit={handleSubmit}
              >
                <div className="relative w-full add-bank-dropdown-bank">
                  <div
                    className="mt-1 flex w-full min-h-[42px] cursor-pointer items-center justify-between border !border-inputfieldborder bg-white px-3 py-2 text-[13px] !font-MontserratMedium text-forgetpassword outline-none"
                    onClick={toggleDropdown}
                  >
                    <span className="text-[13px] font-Montserratmedium text-forgetpassword">
                      {selectedOptions || "Select bank"}
                    </span>
                    <img
                      src="/images/arrow-down.png"
                      alt=""
                      className="h-2 w-2"
                    />
                  </div>

                  {isOpen && (
                    <div className="absolute left-0 z-10 mt-0 w-full rounded-sm border border-subhead bg-white shadow-lg">
                      <ul className="max-h-60 space-y-2 overflow-y-auto p-2">
                        {options.map((option, index) => (
                          <li
                            key={index}
                            className="flex items-center justify-between px-2 hover:bg-gray-100"
                          >
                            <label
                              htmlFor={`bank-${index}`}
                              className="flex flex-1 cursor-pointer items-center justify-between gap-2 text-xs font-Montserratmedium"
                            >
                              <span>{option}</span>
                              <input
                                id={`bank-${index}`}
                                type="radio"
                                name="bankSelect"
                                value={option}
                                checked={selectedOptions === option}
                                onChange={() => {
                                  setSelectedOptions(option);
                                  setErrors((prev) => ({ ...prev, bank: "" }));
                                  setIsOpen(false);
                                }}
                                className="h-4 w-4 shrink-0 accent-subhead border !border-subhead"
                              />
                            </label>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {errors?.bank && (
                    <p className="mt-1 text-xs text-red-500">{errors.bank}</p>
                  )}
                </div>

                <div className="relative w-full add-bank-dropdown-type">
                  <div
                    className="mt-1 flex w-full min-h-[42px] cursor-pointer items-center justify-between border !border-inputfieldborder bg-white px-3 py-2 text-[13px] !font-MontserratMedium text-forgetpassword outline-none"
                    onClick={toggleDropdowntwo}
                  >
                    <span className="text-[13px] font-Montserratmedium text-forgetpassword">
                      {selectedOptions2 || "Select bank account type"}
                    </span>
                    <img
                      src="/images/arrow-down.png"
                      alt=""
                      className="h-2 w-2"
                    />
                  </div>

                  {isOpens && (
                    <div className="absolute left-0 z-10 mt-0 w-full rounded-sm border border-subhead bg-white shadow-lg">
                      <ul className="max-h-60 space-y-2 overflow-y-auto p-2">
                        {optionstwo.map((option, index) => (
                          <li
                            key={index}
                            className="flex items-center justify-between px-2 hover:bg-gray-100"
                          >
                            <label
                              htmlFor={`account-type-${index}`}
                              className="flex flex-1 cursor-pointer items-center justify-between gap-2 text-xs font-Montserratmedium"
                            >
                              <span>{option}</span>
                              <input
                                id={`account-type-${index}`}
                                type="radio"
                                name="accountTypeSelect"
                                value={option}
                                checked={selectedOptions2 === option}
                                onChange={() => {
                                  setSelectedOptions2(option);
                                  setErrors((prev) => ({
                                    ...prev,
                                    accountType: "",
                                  }));
                                  setIsOpens(false);
                                }}
                                className="h-4 w-4 shrink-0 accent-subhead border !border-subhead"
                              />
                            </label>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {errors?.accountType && (
                    <p className="mt-1 text-xs text-red-500">
                      {errors.accountType}
                    </p>
                  )}
                </div>
                <div className="">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    maxLength={50}
                    placeholder="Enter beneficiary name"
                    required
                    value={form?.name}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only alphabets and spaces (no numbers or special characters)
                      const lettersOnly = value.replace(/[^a-zA-Z\s]/g, "");
                      if (lettersOnly !== value) {
                        e.target.value = lettersOnly;
                      }
                      handleInputChange(e);
                    }}
                    className="mt-1 w-full px-3 py-2 border !border-inputfieldborder pr-10 bg-white outline-none text-13 font-Montserratmedium text-forgetpassword min-h-[42px]"
                  />
                  {errors?.name && (
                    <p className="text-red-500 text-xs mt-1">{errors?.name}</p>
                  )}
                </div>
                <div className="">
                  <input
                    type="text"
                    id="address"
                    name="accountNumber"
                    maxLength={12}
                    placeholder="Enter bank account number"
                    required
                    value={form?.accountNumber}
                    onChange={handleInputChange}
                    className="mt-1 w-full px-3 py-2 border !border-inputfieldborder pr-10 bg-white outline-none text-13 font-Montserratmedium text-forgetpassword min-h-[42px]"
                  />
                  {errors?.accountNumber && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors?.accountNumber}
                    </p>
                  )}
                </div>
                <div className="">
                  <input
                    type="text"
                    id="contactnumber"
                    maxLength={12}
                    name="reaccountNumber"
                    placeholder="Re-Enter bank account number"
                    required
                    value={form?.reaccountNumber}
                    onChange={handleInputChange}
                    className="mt-1 w-full px-3 py-2 border !border-inputfieldborder pr-10 bg-white outline-none text-13 font-Montserratmedium text-forgetpassword min-h-[42px]"
                  />
                  {errors?.reaccountNumber && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors?.reaccountNumber}
                    </p>
                  )}
                </div>
                <div className="">
                  <input
                    type="text"
                    id="registration"
                    name="IFSCcode"
                    placeholder="IFSC code"
                    required
                    value={form?.IFSCcode}
                    onChange={handleInputChange}
                    className="mt-1 w-full px-3 py-2 border !border-inputfieldborder pr-10 bg-white outline-none text-13 font-Montserratmedium text-forgetpassword min-h-[42px]"
                  />
                  {errors?.IFSCcode && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors?.IFSCcode}
                    </p>
                  )}
                </div>

                <button
                  type="submit"
                  className="mt-4 px-8 py-2 bg-buttonbg text-13 text-white focus:outline-none font-BonaNovaRegular w-full"
                >
                  Add
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className="md:w-6/12 w-full hidden md:block">
          <SignupSlider />
        </div>
      </div>
    </>
  );
};

export default AddBankDetails;
